import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import Cookies from 'js-cookie';
import { axiosInstance } from '../utils/tokenUtils';

const ProfileContext = createContext(undefined);

const ProfileProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const didInitRef = useRef(false);
  const inFlightRef = useRef(false);

  const fetchProfile = async () => {
    if (inFlightRef.current) return;

    const token = Cookies.get('access_token');
    if (!token) {
      return;
    }

    inFlightRef.current = true;
    setLoading(true);
    setError(null);
    try {
      const { data } = await axiosInstance.get('/auth/users/me');
      setProfile(data || null);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
      inFlightRef.current = false;
    }
  };

  const refreshProfile = async () => {
    await fetchProfile();
  };

  const updateProfile = partialUpdate => {
    setProfile(prev => ({ ...(prev || {}), ...(partialUpdate || {}) }));
  };

  useEffect(() => {
    if (didInitRef.current) return;
    didInitRef.current = true;

    const token = Cookies.get('access_token');
    if (token) {
      fetchProfile();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ProfileContext.Provider value={{ profile, loading, error, refreshProfile, updateProfile }}>
      {children}
    </ProfileContext.Provider>
  );
};

const useProfile = () => {
  const ctx = useContext(ProfileContext);
  if (ctx === undefined) {
    // Provide a safe fallback for tests or places not wrapped yet
    return {
      profile: null,
      loading: false,
      error: null,
      refreshProfile: async () => {},
      updateProfile: () => {},
    };
  }
  return ctx;
};

export { ProfileProvider, useProfile };
